<template>
    <section>
        <div class="demo-grid mdc-layout-grid">
            <div class="mdc-layout-grid__inner">
                <!-- <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 align-center login-logo">
                    <router-link to="/">
                        <img :src="brandLogo" alt="">
                    </router-link>
                    
                </div> -->
                <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 align-center">
                    <span class="t-headline3">
                        {{$t('1526')}}
                        <!-- 이미 가입된 계정 -->
                    </span>
                </div>
               
                <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
                    
                    <div class="t-body3 t-color-content1 align-center mt30">
                        {{$t('1527')}}<br>
                        {{$t('1528')}}
                        <!-- 기존에 가입된 SNS 계정이 존재합니다.<br>
                        가입하신 SNS 계정으로 로그인해주세요. -->
                    </div>

                    <div class="mt60 align-center">
                        <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click="$moveLogin()">
                            {{$t('1529')}}
                            <!-- 로그인하기 -->
                        </button>
                    </div>
                    
                    

                </div>
            </div>
        </div>
    </section>
</template>

<script>

export default {
    data() {
        return {
            brandLogo: localStorage.brandLogo,
        }
    },
    created() {
        // firebase 초기화
        // firebase.initializeApp(firebaseConfig)
    },
    methods: {
        

    }
}
</script>

<style>

</style>
